/* Storuu theme JavaScript. Vanilla JS, no dependencies. Uses the native Cart AJAX API. */
(function () {
  'use strict';

  var T = window.theme || { cartType: 'drawer', routes: {}, strings: {} };
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---------- Header: mobile menu and search ---------- */
  function togglePanel(button, panel, forceClose) {
    if (!button || !panel) return;
    var open = !forceClose && panel.hidden;
    panel.hidden = !open;
    button.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      var focusTarget = $('input, a', panel);
      if (focusTarget) focusTarget.focus();
    }
  }

  document.addEventListener('click', function (event) {
    var menuBtn = event.target.closest('[data-menu-toggle]');
    var searchBtn = event.target.closest('[data-search-toggle]');
    var mobileNav = $('[data-mobile-nav]');
    var searchPanel = $('[data-search-panel]');
    var searchToggle = $('[data-search-toggle]');
    var menuToggle = $('[data-menu-toggle]');

    if (menuBtn) {
      togglePanel(menuBtn, mobileNav);
      togglePanel(searchToggle, searchPanel, true);
      return;
    }
    if (searchBtn) {
      togglePanel(searchBtn, searchPanel);
      togglePanel(menuToggle, mobileNav, true);
      return;
    }
  });

  /* ---------- Cart ---------- */
  var lastFocus = null;

  function drawer() { return $('[data-cart-drawer]'); }

  function openDrawer() {
    var el = drawer();
    if (!el) return false;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var focusable = $('.drawer__panel button, .drawer__panel a, .drawer__panel input', el);
    if (focusable) focusable.focus();
    return true;
  }

  function closeDrawer() {
    var el = drawer();
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function setStatus(message) {
    $$('[data-cart-status]').forEach(function (el) { el.textContent = message || ''; });
  }

  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = !count;
    });
  }

  function fetchJson(url, options) {
    return fetch(url, options).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) {
          var err = new Error(data.description || data.message || T.strings.error);
          err.data = data;
          throw err;
        }
        return data;
      });
    });
  }

  function replaceFromHtml(html, selector, sourceRoot) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var source = $(selector, doc);
    var target = $(selector, sourceRoot || document);
    if (source && target) target.innerHTML = source.innerHTML;
  }

  function refreshCart() {
    return fetchJson(T.routes.cartJson, { headers: { Accept: 'application/json' } }).then(function (cart) {
      updateCount(cart.item_count);
      var tasks = [];

      if (drawer()) {
        tasks.push(
          fetch(T.routes.root + '?sections=cart-drawer')
            .then(function (r) { return r.json(); })
            .then(function (sections) {
              var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
              var newPanel = $('[data-cart-drawer-inner]', doc);
              var panel = $('[data-cart-drawer-inner]', drawer());
              if (newPanel && panel) panel.innerHTML = newPanel.innerHTML;
            })
        );
      }

      if ($('.cart-page')) {
        tasks.push(
          fetch(window.location.href)
            .then(function (r) { return r.text(); })
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var items = $('.cart-page [data-cart-items]', doc);
              var footer = $('.cart-page__footer [data-cart-footer]', doc);
              var curItems = $('.cart-page [data-cart-items]');
              var curFooter = $('.cart-page__footer [data-cart-footer]');
              if (items && curItems) curItems.innerHTML = items.innerHTML;
              if (footer && curFooter) curFooter.innerHTML = footer.innerHTML;
            })
        );
      }
      return Promise.all(tasks).then(function () { return cart; });
    });
  }

  function changeLine(line, quantity) {
    setStatus(T.strings.loading || '');
    return fetchJson(T.routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(quantity) })
    })
      .then(refreshCart)
      .then(function () { setStatus(T.strings.updated); })
      .catch(function (err) { setStatus(err.message || T.strings.error); });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-cart-trigger]');
    if (trigger && T.cartType === 'drawer' && window.location.pathname !== T.routes.cart && drawer()) {
      event.preventDefault();
      openDrawer();
      return;
    }
    if (event.target.closest('[data-drawer-close]')) {
      closeDrawer();
      return;
    }
    var qtyBtn = event.target.closest('[data-qty-btn]');
    if (qtyBtn) {
      var row = qtyBtn.closest('.cart-line');
      var input = $('[data-qty-input]', row);
      var next = Math.max(0, Number(input.value || 0) + Number(qtyBtn.getAttribute('data-delta')));
      input.value = next;
      changeLine(qtyBtn.getAttribute('data-line'), next);
      return;
    }
    var remove = event.target.closest('[data-remove]');
    if (remove) {
      event.preventDefault();
      changeLine(remove.getAttribute('data-line'), 0);
    }
  });

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-qty-input]');
    if (input) changeLine(input.getAttribute('data-line'), Math.max(0, Number(input.value || 0)));
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var el = drawer();
    if (el && el.classList.contains('is-open')) closeDrawer();
    var mobileNav = $('[data-mobile-nav]');
    var searchPanel = $('[data-search-panel]');
    if (mobileNav && !mobileNav.hidden) togglePanel($('[data-menu-toggle]'), mobileNav, true);
    if (searchPanel && !searchPanel.hidden) togglePanel($('[data-search-toggle]'), searchPanel, true);
  });

  /* ---------- Add to cart and Buy now ---------- */
  function showFormError(form, message) {
    var errorEl = $('[data-form-error]', form);
    if (errorEl) { errorEl.textContent = message; errorEl.hidden = false; }
  }

  function selectionIsValid(form) {
    var idField = form.elements['id'];
    var qtyField = form.elements['quantity'];
    var qty = qtyField ? Number(qtyField.value) : 1;
    return !!(idField && idField.value) && qty >= 1 && Math.floor(qty) === qty;
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-buy-now]');
    if (!btn) return;
    var form = btn.closest('form');
    if (form) form.setAttribute('data-buy-now-intent', 'true');
  });

  /* Coming back from checkout (back button) must not leave Buy now state behind */
  window.addEventListener('pageshow', function () {
    $$('input[data-buy-now-flag]').forEach(function (el) { el.parentNode.removeChild(el); });
    $$('form[data-buy-now-intent]').forEach(function (f) { f.removeAttribute('data-buy-now-intent'); });
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[data-type="add-to-cart-form"]');
    if (!form) return;

    var errorEl = $('[data-form-error]', form);
    if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }

    var submitter = event.submitter;
    /* Buy now is recognised from the submit button, or from the click that started the submit
       (older browsers do not report event.submitter). */
    var isBuyNow = !!(submitter && submitter.hasAttribute && submitter.hasAttribute('data-buy-now')) ||
      (!submitter && form.getAttribute('data-buy-now-intent') === 'true');
    form.removeAttribute('data-buy-now-intent');
    var flag = $('input[data-buy-now-flag]', form);
    if (flag && !isBuyNow) flag.parentNode.removeChild(flag);

    if (!selectionIsValid(form)) {
      event.preventDefault();
      showFormError(form, T.strings.invalid || T.strings.error);
      return;
    }

    if (isBuyNow) {
      var buyBtn = $('[data-buy-now]', form);
      if (buyBtn && buyBtn.disabled) { event.preventDefault(); showFormError(form, T.strings.invalid || T.strings.error); return; }
      /* Let the browser submit natively: the platform adds the selected variant and quantity,
         then redirects to checkout because the request carries the "checkout" parameter. */
      if (!submitter && !flag) {
        var hidden = document.createElement('input');
        hidden.type = 'hidden'; hidden.name = 'checkout'; hidden.value = '';
        hidden.setAttribute('data-buy-now-flag', '');
        form.appendChild(hidden);
      }
      return;
    }

    event.preventDefault();

    var button = $('[data-add-to-cart]', form);
    var text = $('[data-add-text]', form);
    if (!button || button.disabled || button.getAttribute('aria-busy') === 'true') return;

    var original = text ? text.textContent : '';
    button.setAttribute('aria-busy', 'true');
    if (text) text.textContent = T.strings.adding;

    fetchJson(T.routes.cartAdd, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function () { return refreshCart(); })
      .then(function () {
        setStatus(T.strings.added);
        if (T.cartType === 'drawer' && drawer()) {
          openDrawer();
        } else {
          window.location.href = T.routes.cart;
        }
      })
      .catch(function (err) { showFormError(form, err.message || T.strings.error); })
      .then(function () {
        button.removeAttribute('aria-busy');
        if (text) text.textContent = original;
      });
  });

  /* ---------- Product page: gallery, zoom, quantity, variants ---------- */
  function selectMedia(section, mediaId) {
    if (!mediaId) return;
    var found = false;
    $$('[data-slide]', section).forEach(function (slide) {
      var match = slide.getAttribute('data-media-id') === String(mediaId);
      slide.hidden = !match;
      if (match) found = true;
    });
    if (!found) return;
    $$('[data-thumb]', section).forEach(function (thumb) {
      if (thumb.getAttribute('data-media-id') === String(mediaId)) thumb.setAttribute('aria-current', 'true');
      else thumb.removeAttribute('aria-current');
    });
  }

  function stepMedia(section, dir) {
    var slides = $$('[data-slide]', section);
    if (slides.length < 2) return;
    var current = 0;
    slides.forEach(function (slide, i) { if (!slide.hidden) current = i; });
    var next = (current + dir + slides.length) % slides.length;
    selectMedia(section, slides[next].getAttribute('data-media-id'));
  }

  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('[data-thumb]');
    if (thumb) {
      selectMedia(thumb.closest('[data-product-section]'), thumb.getAttribute('data-media-id'));
      return;
    }
    var zoom = event.target.closest('[data-zoom-src]');
    if (zoom) {
      var section = zoom.closest('[data-product-section]');
      var dialog = $('[data-zoom-dialog]', section);
      var img = $('[data-zoom-img]', section);
      if (dialog && img && typeof dialog.showModal === 'function') {
        img.src = zoom.getAttribute('data-zoom-src');
        img.alt = zoom.getAttribute('data-zoom-alt') || '';
        dialog.showModal();
      }
      return;
    }
    if (event.target.closest('[data-zoom-close]')) {
      var dlg = event.target.closest('dialog');
      if (dlg) dlg.close();
      return;
    }
    if (event.target.matches && event.target.matches('[data-zoom-dialog]')) {
      event.target.close();
      return;
    }
    var step = event.target.closest('[data-qty-step]');
    if (step) {
      var wrap = step.closest('.qty');
      var qtyInput = $('.qty__input', wrap);
      var value = Math.max(Number(qtyInput.min || 1), Number(qtyInput.value || 1) + Number(step.getAttribute('data-qty-step')));
      qtyInput.value = value;
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  function initProduct(section) {
    var jsonEl = $('[data-variants]', section);
    if (!jsonEl) return;
    var variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    section.addEventListener('change', function (event) {
      if (!event.target.closest('[data-variant-picker]')) return;

      var selected = $$('[data-variant-picker] fieldset', section).map(function (fieldset) {
        var checked = $('input:checked', fieldset);
        return checked ? checked.value : null;
      });

      var variant = variants.filter(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      })[0];

      var button = $('[data-add-to-cart]', section);
      var text = $('[data-add-text]', section);
      var buyNow = $('[data-buy-now]', section);
      var idInput = $('[data-variant-id]', section);
      var stickyBtn = $('[data-sticky-submit]', section);
      var stickyText = $('[data-sticky-text]', section);
      var stickyBuy = $('[data-sticky-buy]', section);

      if (!variant) {
        if (idInput) idInput.value = '';
        if (button) button.disabled = true;
        if (buyNow) buyNow.disabled = true;
        if (stickyBtn) stickyBtn.disabled = true;
        if (stickyBuy) stickyBuy.disabled = true;
        if (text) text.textContent = T.strings.unavailable;
        if (stickyText) stickyText.textContent = T.strings.unavailable;
        return;
      }

      if (idInput) idInput.value = variant.id;
      if (button) button.disabled = !variant.available;
      if (buyNow) buyNow.disabled = !variant.available;
      if (stickyBtn) stickyBtn.disabled = !variant.available;
      if (stickyBuy) stickyBuy.disabled = !variant.available;
      var label = variant.available ? T.strings.addToCart : T.strings.soldOut;
      if (text) text.textContent = label;
      if (stickyText) stickyText.textContent = label;
      if (variant.media) selectMedia(section, variant.media);

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());

      var sectionId = section.getAttribute('data-section-id');
      fetch(section.getAttribute('data-product-url') + '?variant=' + variant.id + '&section_id=' + encodeURIComponent(sectionId))
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newPrice = $('[data-price]', doc);
          var price = $('[data-price]', section);
          if (newPrice && price) price.innerHTML = newPrice.innerHTML;
          var stickyPrice = $('[data-sticky-price]', section);
          if (newPrice && stickyPrice) stickyPrice.innerHTML = newPrice.innerHTML;
          var newAvail = $('[data-availability]', doc);
          var avail = $('[data-availability]', section);
          if (newAvail && avail) avail.innerHTML = newAvail.innerHTML;
        })
        .catch(function () {});
    });
  }

  function initSwipe(section) {
    var stage = $('[data-gallery-stage]', section);
    if (!stage) return;
    var startX = null;
    stage.addEventListener('touchstart', function (e) { startX = e.changedTouches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      startX = null;
      if (Math.abs(dx) < 40) return;
      stepMedia(section, dx < 0 ? 1 : -1);
    }, { passive: true });
  }

  function initSticky(section) {
    var bar = $('[data-sticky-atc]', section);
    var addBtn = $('[data-add-to-cart]', section);
    var submit = $('[data-sticky-submit]', section);
    var stickyBuy = $('[data-sticky-buy]', section);
    var buyBtn = $('[data-buy-now]', section);
    if (!bar || !addBtn || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      var entry = entries[0];
      bar.hidden = !(!entry.isIntersecting && entry.boundingClientRect.top < 0);
      document.body.classList.toggle('has-sticky-atc', !bar.hidden);
    }).observe(addBtn);
    if (submit) submit.addEventListener('click', function () { addBtn.click(); });
    if (stickyBuy && buyBtn) stickyBuy.addEventListener('click', function () { if (!buyBtn.disabled) buyBtn.click(); });
    new MutationObserver(function () { document.body.classList.toggle('has-sticky-atc', !bar.hidden); }).observe(bar, { attributes: true, attributeFilter: ['hidden'] });
  }

  $$('[data-product-section]').forEach(function (section) {
    initProduct(section);
    initSwipe(section);
    initSticky(section);
  });

  /* ---------- Related products (recommendations API) ---------- */
  $$('[data-recommendations]').forEach(function (container) {
    var url = container.getAttribute('data-url');
    if (!url || container.querySelector('.grid')) return;
    fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var source = $('[data-recommendations]', doc);
        if (source && source.querySelector('.grid')) container.innerHTML = source.innerHTML;
      })
      .catch(function () {});
  });

  /* ---------- Collection filters: submit on change ---------- */
  $$('[data-filter-form]').forEach(function (form) {
    form.addEventListener('change', function (event) {
      if (event.target.closest('[data-filter-input]')) form.submit();
    });
  });

  /* ---------- Copy discount code ---------- */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-copy-code]');
    if (!btn) return;
    var label = $('[data-copy-label]', btn);
    var done = function () {
      if (!label) return;
      var original = label.textContent;
      label.textContent = 'Copied';
      setTimeout(function () { label.textContent = original; }, 2000);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(btn.getAttribute('data-copy-code')).then(done, function () {});
    }
  });

  /* ---------- Order tracking ---------- */
  $$('[data-tracking-form]').forEach(function (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var number = $('[data-tracking-number]', form).value.trim();
      var error = $('[data-tracking-error]', form);
      var courier = $('[data-tracking-courier]', form);
      var template = (courier && courier.value) || form.getAttribute('data-default-url') || '';

      if (!number) {
        if (error) { error.textContent = 'Please enter a tracking number.'; error.hidden = false; }
        return;
      }
      if (!/^https?:\/\//i.test(template)) {
        if (error) { error.textContent = 'Tracking is not available right now. Please contact us.'; error.hidden = false; }
        return;
      }
      if (error) error.hidden = true;
      var encoded = encodeURIComponent(number);
      var target = template.indexOf('{number}') > -1 ? template.split('{number}').join(encoded) : template + encoded;
      window.open(target, '_blank', 'noopener');
    });
  });
  /* ---------- Header logo: shrink on scroll (home and product pages) ---------- */
  (function () {
    var cls = document.body.className;
    if (!/(^|\s)template-(index|product)(\s|$)/.test(cls)) return;
    var header = $('[data-header]');
    if (!header) return;
    var shrunk = false;
    var ticking = false;
    function update() {
      ticking = false;
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      /* Two thresholds stop the logo flickering around a single scroll position */
      if (!shrunk && y > 48) shrunk = true;
      else if (shrunk && y < 12) shrunk = false;
      header.classList.toggle('is-shrunk', shrunk);
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    update();
  })();
  /* ---------- Gentle scroll reveal (visual only; content stays visible if anything fails) ---------- */
  (function () {
    try {
      if (!('IntersectionObserver' in window)) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var targets = document.querySelectorAll('.benefit, .steps__item, .trust-strip__item, .collection-grid .card, .featured__grid > *, .brand-intro__grid > *, .accordion, .tracking__form, .cta__inner');
      if (!targets.length) return;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      Array.prototype.forEach.call(targets, function (el, i) {
        if (el.getBoundingClientRect().top < vh) return; /* already on screen: leave untouched */
        el.classList.add('reveal');
        el.style.setProperty('--reveal-delay', ((i % 4) * 0.08) + 's');
        io.observe(el);
      });
    } catch (e) { /* never block the page */ }
  })();
})();
